import { render, staticRenderFns } from "./LoginByToken.vue?vue&type=template&id=23c74181&scoped=true"
import script from "./LoginByToken.vue?vue&type=script&lang=js"
export * from "./LoginByToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c74181",
  null
  
)

export default component.exports